(function () {
  'use strict';

  var root = document.querySelector('[data-loa-feedback]');
  if (!root) return;

  var form = root.querySelector('form');
  var ratingInput = root.querySelector('[name="rating"]');
  var ratingButtons = Array.prototype.slice.call(root.querySelectorAll('[data-rating]'));
  var errorBox = root.querySelector('[data-feedback-error]');
  var formPanel = root.querySelector('[data-feedback-form]');
  var successPanel = root.querySelector('[data-feedback-success]');
  var submitButton = root.querySelector('[type="submit"]');
  var params = new URLSearchParams(window.location.search);

  function setRating(value) {
    var rating = Number(value);
    if (!Number.isInteger(rating) || rating < 1 || rating > 5) return;
    ratingInput.value = String(rating);
    ratingButtons.forEach(function (button) {
      var active = Number(button.getAttribute('data-rating')) === rating;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  ratingButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setRating(button.getAttribute('data-rating'));
    });
  });

  setRating(params.get('rating'));

  form.addEventListener('submit', async function (event) {
    event.preventDefault();
    errorBox.hidden = true;

    var data = new FormData(form);
    if (data.get('company')) return;

    var rating = Number(data.get('rating'));
    var email = String(data.get('email') || '').trim();
    if (!Number.isInteger(rating) || rating < 1 || rating > 5) {
      errorBox.textContent = 'Please choose a rating from 1 to 5.';
      errorBox.hidden = false;
      return;
    }
    if (!/^\S+@\S+\.\S+$/.test(email)) {
      errorBox.textContent = 'Please enter the email used for your order.';
      errorBox.hidden = false;
      return;
    }

    submitButton.disabled = true;
    submitButton.textContent = 'Sending…';

    var payload = {
      email: email,
      rating: rating,
      feedback_category: String(data.get('category') || 'not-specified'),
      feedback_text: String(data.get('feedback') || '').slice(0, 4000),
      follow_up_allowed: data.get('follow_up_allowed') === 'yes',
      campaign_source: params.get('source') || 'direct'
    };

    try {
      var response = await fetch('https://loa-feedback-endpoint-62194280051.us-east1.run.app/feedback', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify(payload)
      });
      var responseData = await response.json().catch(function () { return {}; });
      if (!response.ok) {
        throw new Error(responseData.error || 'feedback-submit-failed');
      }

      formPanel.hidden = true;
      successPanel.hidden = false;
      successPanel.querySelector('[data-feedback-outcome]').textContent = rating <= 3
        ? 'We are sorry the experience fell short. Our reader-care team will use your response to help put it right.'
        : 'We are grateful to know the Library has served you well.';
      successPanel.focus();
    } catch (submissionError) {
      errorBox.textContent = submissionError && submissionError.message === 'order_email_not_found'
        ? 'We could not find that order email. Please enter the email used at checkout or reply to our email.'
        : 'We could not save your feedback. Please try again or reply to our email.';
      errorBox.hidden = false;
      submitButton.disabled = false;
      submitButton.textContent = 'Send my private feedback';
    }
  });
})();
